/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { rendererIconByName, ROW_DIRTY_CLASS, truthyCellRenderer } from '@gh/common-internal-shared';
import { NumberTypes } from '@gh/common-shared';
import { buildNumberColumn, GridOptionsExt, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { isNil } from 'lodash';
import { getPbHousePlanId, PbHousePlan } from '../../../resources/price-book.model';

@Injectable()
export class PbDetailsHpGridDefinitionService extends LayoutBasedGridDefinition {

  buildGridOptions(): GridOptionsExt {
    return {
      rowSelection: 'single',
      getRowNodeId: getPbHousePlanId,
      rowClassRules: {
        [ROW_DIRTY_CLASS]: ({ data }: { data: PbHousePlan }) => data && !isNil(data.dirtyType),
      },
    };
  }

  buildColumnDefs(): Hash<ColDef> {
    return {
      'isQqAllowed': {
        cellRenderer: truthyCellRenderer(rendererIconByName('done')),
      },
      'isQq': {
        cellRenderer: truthyCellRenderer(rendererIconByName('done')),
      },
      qqMarkupPct: buildNumberColumn(NumberTypes.Percents_2),
      floorArea: buildNumberColumn(NumberTypes.Quantity_2),
      cost: buildNumberColumn(NumberTypes.Price),
    };
  }
}
